// Lib
import React from 'react';
import PropTypes from 'prop-types';
import AnimateHeight from 'react-animate-height';
import { CSSTransitionGroup } from '../../../node_module_clones/react-transition-group';
import Measure from '../../../node_module_clones/react-measure/src/Measure';

/**
 * This component Animates the height of the children on change and applies a transition to them too.
 *
 * Unfortunately I needed to use "componentWillReceiveProps" here as useLayoutEffect seems to be
 * fired too late.
 */
class AnimateHeightOnChildChange extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            animatedHeight: 'auto',
        };

        this.animateHeightRef = React.createRef();

        this.childHeight = null;
    }

    componentDidUpdate(prevProps) {
        if (prevProps.children.key !== this.props.children.key) {
            // Needed to set the height via the actual DOM element, otherwise AnimateHeight would take an extra
            // frame and the height would flash
            this.animateHeightRef.current.contentElement.style.height = `${this.childHeight}px`;

            this.setState({ animatedHeight: this.childHeight });

            const { duration = 300 } = this.props;

            setTimeout(() => {
                this.animateHeightRef.current.contentElement.style.height = null;
                this.setState({ animatedHeight: 'auto' });
            }, duration + 50);
        }
    }

    onMeasure = ({ height }) => {
        this.childHeight = height;
    };

    render() {
        const { children, transition = 'slide-left', duration = 300 } = this.props;

        return (
            <AnimateHeight
                className="AnimateHeightOnChildChange"
                ref={this.animateHeightRef}
                duration={duration}
                height={this.state.animatedHeight}
            >
                <CSSTransitionGroup
                    transitionName={transition}
                    transitionEnterTimeout={duration + 32}
                    transitionLeaveTimeout={duration + 32}
                >
                    <Measure key={`measure-${children.key}`} whitelist={['height']} onMeasure={this.onMeasure}>
                        {children}
                    </Measure>
                </CSSTransitionGroup>
            </AnimateHeight>
        );
    }
}

AnimateHeightOnChildChange.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
    className: PropTypes.string,
    transition: PropTypes.string,
    duration: PropTypes.number,
};

export default AnimateHeightOnChildChange;
